import { render, staticRenderFns } from "./OarShippedSummary.vue?vue&type=template&id=6b63a543&scoped=true"
import script from "./OarShippedSummary.vue?vue&type=script&lang=js"
export * from "./OarShippedSummary.vue?vue&type=script&lang=js"
import style0 from "./OarShippedSummary.vue?vue&type=style&index=0&id=6b63a543&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b63a543",
  null
  
)

export default component.exports